import React from 'react';
import { Content } from './shared';

const CignaGaiamYoga = () => (
  <Content>
    Visit the Gaiam Yoga website and use code <i>CIGNA</i> to unlock your discount at checkout.
  </Content>
);

export default CignaGaiamYoga;
